import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";

import { IntegrationService } from "../../../app/services";
import { ErrorPageCode } from "../../../app/app.enums";

export const licenseAgentGuard: CanActivateFn = async (
  route,
  state
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const integration = inject(IntegrationService);

  switch (route.url[0].path) {
    case "a":
      if (integration.hasLicense("video")) {
        return true;
      }
      return router.createUrlTree(
        ["/error", ErrorPageCode.LICENSE_REQUIRED],
        { queryParamsHandling: "preserve" }
      );
    default:
      return true;
  }
};
